import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { notificationActions } from '../../store/actions'//Acciones para redux
// import {
//   mainStyles,//Estílos genéricos
// } from '../../styles'//Se importan los estilos genéricos
import { useNavigate, useLocation } from 'react-router-dom'//React routes
import {
  TextField,//Campos
  Typography,//Textos
  Grid,
  useTheme
} from '@mui/material'//Se importan elementos de la librería material-ui

import {
  CustomCounterAppBar, CustomLoadingOverlay
,Buttons } from '../../components'

//Funciones y estílos específicos de éste componente
// import { useStyles } from './IdentityDocumentSelectorStyles'//Estílos específicos de los elementos de este componente
import { IdentityFunctions } from './IdentityDocumentSelectorFunctions'//Métodos de éste componente (no requieren state)
import { coreFunctions } from '../../utils'
import { useTranslation } from 'react-i18next'
export default function IdentityDocumentSelectorComponent(props) {
  const { useState, useEffect } = React//Hook para el state
  const [userData, setUserData] = useState([])
  const [loadView, setLoadView] = useState(false)//Se muestra/oculta el gif loader
   const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()//estílos genéricos (Main.js)
  const gridContainer = {} //mainStyles.gridStyle()
  const localStyles = {}//useStyles()//estílos de este componente (LoginStyles.js)
  const fieldStyles = {} //mainStyles.useStylesField()//Estílos genérico de campos (Main.js)
  const navigate = useNavigate()//Módulo "History" de react router

  //Estados de componente
  const [fullName, setFullName] = useState('')
  const [email, setEmail] = useState('')
  const [phoneNumber, setPhoneNumber] = useState('')
  const [sendCodeRetries, setRetries] = useState(1)
  const [stageDescription, setDescription] = useState('Código de seguridad')
  const [timeLeft, setTimeLeft] = useState(60);
  const [activateResend, setActivateResend] = useState(false);

  const [code, setCode] = useState('')//State CODE
  const [otpIsSended, setStatus] = useState(false)//State CODE
  let timer = null;

  //Redux hooks
  const auth = useSelector(state => state.Authentication)
  const wf = useSelector(state => state.Workflow)
  const file = useSelector(state => state.FileInfo)
  const notification = useSelector(state => state.ReSendNip)
  const otpSended = useSelector(state => state.SendNip)
  const dispatch = useDispatch()


  /*Comienzan métodos y escuchas de componente**/
  const [currentStage, setCurrentStage] = useState(0)
  const [stageProps, setStageProps] = useState(0)
  const [totalStage, setTotalStage] = useState(0)
  const [stateActual, setStateActual] = useState('')
  const [stateCurrent, setStateCurrent] = useState('')
  const { t } = useTranslation();



  useEffect(() => {
    if (stageProps != 0) {
      setCurrentStage(stageProps.CurrentStageGroup)
      setTotalStage(stageProps.TotalStageGroups)
    }
  }, [stageProps])

  useEffect(() => {
    let stageName = location.state.stageName
    let stageId = location.state.stageId
    // setNameStage(stageName)        
    if (wf.items != undefined) {
      let items = wf.items
      items.forEach(i => {
        let stages = i.Stages
        let stgPrp = stages.find(j => j.Id === stageId && j.Name === stageName)
        setStageProps(stgPrp)
      });
    }
  }, [wf])
  //Promesa general Init
  useEffect(() => {

  })

  //Obtener valores de persistencia de datos y mostrarlos en interfaz
  useEffect(() => {
    //Se cachan parámetros de salida en UI desde persistencia de datos, nombre, correo y teléfono
    if (file.items != undefined) {

      setDescription(file.items.Stage.Description)
    }

  }, [file])



  //Comienza interfaz
  return (

    <div className={gridContainer.container}>
      <div className={gridContainer.leftColumn}></div>
      <div className={gridContainer.centerColumn}>
        <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />
        {/* {loadView ? 
          <LoadingOverlay
            active={loadView}
            spinner
            text='Espere un momento por favor...'
            className={classes.loader}>
        </LoadingOverlay> : null} */}

        <CustomCounterAppBar initialStep={currentStage} endingStep={totalStage} />

        <div className={gridContainer.centerContent1}>
          <Grid container spacing={3} >
            <Grid item xs={12}>
              <Typography variant="h2" gutterBottom className={localStyles.title}>{stageDescription}</Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>Se ha enviado un código a <b>{fullName}</b> al número <b>{phoneNumber}</b> y correo <b>{email}</b></Typography>
            </Grid>
            <Grid item xs={12}>
              <Typography variant="h6" gutterBottom>Introduce el código de seguridad.</Typography>
            </Grid>
            <Grid container spacing={1} >
              <Grid item xs={1} sm={1}> </Grid>

              <Grid item xs={1} sm={1}></Grid>
            </Grid>


          </Grid>
          <br />
        </div>
      </div>
      <div className={gridContainer.rightColumn}></div>
    </div>



  )
}
